import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid py-3 page-main-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col text-center page-main-title" }, [
      /*#__PURE__*/_createElementVNode("h1", { class: "white-text" }, /*#__PURE__*/_toDisplayString('USDT'))
    ])
  ])
], -1)
const _hoisted_3 = { class: "container-fluid underline-container" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row text-center" }
const _hoisted_6 = { class: "usdt-class" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$route.query.usdt??'None'), 1)
        ])
      ])
    ])
  ]))
}